// extracted by mini-css-extract-plugin
module.exports = {"logo-symbol":"_______Desktop_logo-symbol__4zY_s","logo-letter":"_______Desktop_logo-letter__DOlA5","hide":"_______Desktop_hide__z4d0v","enlarge":"_______Desktop_enlarge__GEc_p"};